exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* Color Defination\r\n   ========================================================================== */\n/**\r\n * main color\r\n */\n/*main color*/\n/*main light color*/\n/*second color*/\n/*used in header*/\n/*dark text color*/\n/*light text color*/\n/*very light color*/\n/*mostly used in buttons*/\n/**/\n/**/\n/**\r\n * main color\r\n */\n.reset-password-wrapper {\n  background: #2e323e;\n  text-align: center;\n  min-height: 100vh;\n  min-width: 100%; }\n.reset-password-wrapper .login-logo {\n    padding: 46px 0; }\n.center-box {\n  max-width: 514px;\n  width: 100%;\n  margin: 0 auto 70px;\n  -webkit-box-shadow: 10 1 16 #333;\n          box-shadow: 10 1 16 #333; }\n.center-box .reset-section {\n    padding: 30px 30px 50px;\n    background-color: #ffffff; }\n.center-box .reset-section label {\n      color: #a0a0a0; }\n.center-box .reset-section .btn-primary {\n      min-width: 156px;\n      font-size: 16px;\n      margin-top: 20px; }\n.copy-right {\n  color: #ffffff;\n  padding-bottom: 30px;\n  font-size: 14px; }\n.copy-right span {\n    color: #009eea; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/Xpand-Dubai/xpand_retail_int/Customers/app/src/app/reset-password/reset-password.component.scss
// module id = ../../../../../src/app/reset-password/reset-password.component.scss
// module chunks = main